<template lang="pug">
div
  v-row.mt-sm-5(no-gutters)
    v-col(cols="12" sm="5")
      .d-flex.align-center
        v-text-field.round-lg.search-input(v-model="searchText" @input="queryChanged" :placeholder="$t('search_customer')" hide-details dense solo flat height=40 background-color="neutral300")
          template(v-slot:append)
            eva-icon(name="search-outline" :fill="$colors.primary400")
        template(v-if="isMobileScreen")
          v-btn.ml-2(@click="addFilter" icon color="neutral500")
            v-icon $yzi-filter-line
          customize-column-menu(:showTooltip="false")
          v-btn(v-if="!isSelectionMode && !isGroupMode" @click="addCustomer" icon color="neutral500")
            v-icon mdi-plus

    v-col(cols="12" sm="7" v-if="!isMobileScreen")
      .d-flex
        template(v-if="!isGroupMode")
          v-btn.mt-1.px-3.button-text-normal.ml-2(v-if="!containFilter" @click="addFilter" outlined rounded height=32 :color="$colors.primary200")
            .text-xs.text-none.primary--text {{ $t('add_filter') }}
            v-icon(right color="primary") mdi-plus
          v-btn.mt-1.pl-3.pr-1.ml-2(v-else @click="addFilter" outlined depressed rounded height=32 :color="$colors.primary" :style="`background-color: ${$colors.primaryT08}`")
            .text-xs.font-normal.text-none.primary--text {{ $t('filter_applied') }}
            eva-icon.mt-1(name="chevron-right" fill="#333")
        v-spacer
        v-btn.ml-1.button-md(v-if="isSelectionMode" @click="onContinue" color="info" depressed :disabled="!selectedCustomers.length" :loading="loading") {{ confirmText }}
        v-btn.button-sm(v-if="!isSelectionMode && !isGroupMode" @click="addCustomer" color="info" depressed) 
          v-icon $yzi-userplus-03
          .ml-2 Add customer

  v-row.mt-4(align="center" v-if="!isMobileScreen")
    v-col(cols="12" lg="7")
      .d-flex.align-center
        template(v-if="!isGroupMode && selectedCustomers.length")
          v-btn.button-sm.mr-2(v-if="!isSelectionMode" @click="onDelete" color="danger500" outlined depressed) {{ $t('delete') }}
          v-btn.button-sm.mr-2(v-if="!isSelectionMode" @click="onAddSegment" color="primary" outlined depressed) {{ $t('add_to_segment') }}
          v-btn.button-sm.mr-2(v-if="!isSelectionMode" @click="onSendSms" color="primary" outlined depressed) {{ $t('send_sms') }}
          v-btn.button-sm.mr-2(v-if="!isSelectionMode" @click="onSendEmail" color="primary" outlined depressed) {{ $t('send_email') }}
          v-btn.button-sm.mr-3(v-if="isSelectionMode" color="primary" outlined) {{ $t('added') }} ({{ selectedCustomers.length }})
        template(v-else)
          v-btn.button-sm.mr-2(v-if="selectedCustomers.length && !isSelectionMode" @click="onDeleteCustomerSegment" color="danger500" outlined depressed) {{ $t('delete') }}
        a.link-s.ml-1(v-if="selectedCustomers.length" @click="clearSelection") {{ $t('clear_selection') }}
        v-spacer
    v-col(cols="12" lg="5")
      .d-flex.align-center.justify-end
        customize-column-menu
        yc-pagination-custom.ml-4(v-model="currentPage" :parentPageSize.sync="pageSize" :count="totalCount" :text="$t('show_customers')" @input="pageChanged")

  .mt-4(v-else)
    template(v-if="!isLoading")
      v-divider
      .d-flex.align-center.py-3
        yc-checkbox(v-model="checkAll" @change="onCheckedAll")
        v-menu(v-if="selectedCustomers.length" offset-y)
          template(v-slot:activator="{ on, attrs }")
            v-btn.button-sm(v-on="on" text height=32) Action ({{ selectedCustomers.length }})
              v-icon.ml-1(small) mdi-chevron-down
          v-list.text-sm
            template(v-if="!isGroupMode")
              v-list-item(@click="onDelete" v-if="!isSelectionMode")
                .danger500--text {{ $t('delete') }}
              v-list-item(@click="onAddSegment" v-if="!isSelectionMode")
                div {{ $t('add_to_segment') }}
              v-list-item(@click="onSendSms" v-if="!isSelectionMode")
                div {{ $t('send_sms') }}
              v-list-item(@click="onSendEmail" v-if="!isSelectionMode")
                div {{ $t('send_email') }}
            template(v-else)
              v-list-item(@click="onDeleteCustomerSegment")
                .danger500--text {{ $t('delete') }}
            v-list-item(@click="clearSelection")
              div {{ $t('clear_selection') }}
        v-spacer
        yc-pagination(v-model="currentPage" :pageSize="pageSize" :count="totalCount")
      v-divider

  .yc-table
    v-data-table.mt-sm-4.pb-16(:headers="headers" :items="customers" item-key="id" :items-per-page="pageSize" :hide-default-header="isMobileScreen" :loading="isLoading" hide-default-footer disable-sort)
      template(v-slot:no-data)
        .mt-16
          v-img.mx-auto(src="@/assets/images/icon_empty.png" width=80)
          .mt-2.p2.basic600--text {{ $t('no_list_available') }}
      template(v-slot:header.checked)
        yc-checkbox(v-model="checkAll" @change="onCheckedAll")
      template(v-slot:header.marital_status)
        div Marital status
      template(v-slot:item="{ item, isMobile, headers, index }")
        tr.primary--text(v-if="!isMobile")
          template(v-for="header in headers")
            template(v-if="header.value === 'checked'")
              td.py-4.sticky-column
                yc-checkbox(v-model="item.checked" @change="onChecked")
            template(v-else-if="header.value === 'name'")
              td.py-4.sticky-column
                .font-medium {{ item.name }}
            template(v-else-if="header.value === 'created'")
              td.py-4 {{ item.created | convertServerDate }}
            template(v-else-if="header.value === 'gender'")
              td.py-4 {{ item.gender | capitalize }}
            template(v-else-if="header.value === 'marital_status'")
              td.py-4 {{ item.marital_status | capitalize }}
            template(v-else-if="header.value === 'member'")
              td.py-4 {{ item.member | getMemberName }}
            template(v-else)
              td.py-4 {{ getFieldData(header.value, item) }}
        template(v-else)
          .d-flex.py-3.align-start
            yc-checkbox(v-model="item.checked" @change="onChecked")
            .ml-4.flex-grow-1.text-sm
              .font-medium.mb-2 {{ item.name }}
              template(v-for="header in headers")
                .d-flex.mb-1(v-if="header.value !== 'checked' && header.value !== 'name'")
                  .flex-grow-1
                    .basic600--text {{ header.text | fieldNameDisplay }}
                  div(v-if="header.value === 'created'") {{ item.created | convertServerDate }}
                  div(v-else-if="header.value === 'gender'") {{ item.gender | capitalize }}
                  div(v-else-if="header.value === 'member'") {{ item.member | getMemberName }}
                  div(v-else) {{ getFieldData(header.value, item) }}
          v-divider
    .py-8
    .yc-fixed-bottom-section(v-if="isMobileScreen")
      yc-pagination-custom(v-model="currentPage" :parentPageSize.sync="pageSize" :count="totalCount" text="Show customers" @input="pageChanged")
      slot(name="actions")

  filter-customer-drawer(:open.sync="showFilterDrawer")
  delete-customer-dialog(v-if="showDeleteDialog" :open.sync="showDeleteDialog" :customers="selectedCustomers" @deleted="successDeleteCustomer")
  add-segment-dialog(v-if="showAddDialog" :open.sync="showAddDialog" :customers="selectedCustomers" @success="successAddCustomer")
  delete-customer-segment-dialog(v-if="showDeleteCustomerSegment" :open.sync="showDeleteCustomerSegment" :customers="selectedCustomers" :segment="segment" @deleted="successDeleteCustomer")
  create-customer-dialog(v-if="showCreateCustomerDialog" :open.sync="showCreateCustomerDialog" @success="successAddCustomer")

  y-dialog(v-if="showAddCustomerDialog" v-model="showAddCustomerDialog" max-width=568 fluid scrollable :fullscreen="$vuetify.breakpoint.xsOnly" content-class="round-2xl")
    v-card
      v-card-title.pa-4
        v-spacer 
        .text-xl.font-bold.ml-10 Add customer
        v-spacer
        v-btn(icon @click="showAddCustomerDialog = false" color="primary" small)
          v-icon mdi-close
      v-divider
      v-card-text.pb-12.primary--text
        .pt-8.pb-6
          .text-md.font-medium.mb-4 Select your source of customer
          .text-sm Choose one and click "Confirm"
        v-item-group(mandatory @change="onChanged" flat)
          div(v-for="option in addCustomerOptions" :key="option.id")
            v-item(v-slot="{ active, toggle }")
              .round-xl.pa-4.mb-3(:style="active ? activeStyle : inactiveStyle" @click="toggle" flat rounded="lg")
                .text-md.font-medium.mb-1 {{ option.title }}
                .text-sm.neutral500--text {{ option.description }}
      v-divider
      v-card-actions.px-6.py-3
        v-btn.button-md.underline.ml-n4(@click="showAddCustomerDialog = false" color="primary" text) {{ $t('cancel') }}
        v-spacer
        v-btn.button-md.white--text(@click="confirmAddCustomer" color="primary" depressed) {{ $t('confirm') }}
</template>

<script>
import { debounce } from '@/utils'
import { mapGetters, mapActions } from 'vuex'
import CustomizeColumnMenu from '@/components/connect/CustomizeColumnMenu.vue'
import FilterCustomerDrawer from '@/components/connect/FilterCustomerDrawer.vue'
import DeleteCustomerDialog from '@/components/connect/dialogs/DeleteCustomerDialog.vue'
import AddSegmentDialog from '@/components/connect/dialogs/AddSegmentDialog.vue'
import DeleteCustomerSegmentDialog from '@/components/connect/dialogs/DeleteCustomerSegmentDialog.vue'
import CreateCustomerDialog from '@/components/connect/dialogs/CreateCustomerDialog.vue'

export default {
  props: {
    isSelectionMode: {
      type: Boolean,
      default: false
    },
    isGroupMode: {
      type: Boolean,
      default: false
    },
    confirmText: {
      type: String,
      default: 'Confirm'
    },
    loading: {
      type: Boolean,
      default: false
    },
    previousCustomers: {
      type: Array,
      default: null
    },
    segment: {
      default: null
    }
  },
  components: { CustomizeColumnMenu, FilterCustomerDrawer, DeleteCustomerDialog, AddSegmentDialog, DeleteCustomerSegmentDialog, CreateCustomerDialog },
  data: () => ({
    isLoading: false,
    searchText: '',
    currentPage: 1,
    pageSize: 100,
    totalCount: 0,
    customers: [],
    selectedCustomers: [],
    showFilterDrawer: false,
    isDeleting: false,
    checkAll: false,
    showDeleteDialog: false,
    showDeleteCustomerSegment: false,
    showAddDialog: false,
    showAddCustomerDialog: false,
    showCreateCustomerDialog: false,
    addCustomerOptions: [
      { 
        id: 'create',
        title: 'Add single contact', 
        description: 'Manually add a contact by filiing up required field' 
      },
      { 
        id: 'csv', 
        title: 'Upload CSV', 
        description: 'Import your customers by uploading the completed csv. file template' 
      }
    ],
    selectedAddCustomerOption: null,
    activeStyle: {
      border: '1.5px solid #0C6DFF',
      borderRadius: '4px',
      padding: '16px',
      cursor: 'pointer'
    },
    inactiveStyle: {
      border: '1px solid #C1C1C1',
      borderRadius: '4px',
      padding: '16px',
      cursor: 'pointer'
    }
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
      filters: 'customers/getFilters',
      fields: 'customers/getAllFields'
    }),
    headers () {
      const filteredOptions = this.fields.filter(item => item.enable)
      const checkbox = {
        text: '',
        value: 'checked'
      }
      const name = {
        text: 'Name',
        value: 'name',
        class: 'text-table-header'
      }
      filteredOptions.map(item => {
        item.text = item.field_name
        item.value = `${item.id}`.toLowerCase()
        item['class'] = 'text-table-header'
      })
      return [checkbox, name, ...filteredOptions]
    },
    containFilter () {
      let data = false
      for (const key in this.filters) {
        const value = this.filters[key]
        if (value) {
          if (key === 'custom_data') {
            if (value.size) {
              data = true
            }
          } else {
            data = true
          }
        }
      }
      return data
    },
    isMobileScreen () {
      return this.$vuetify.breakpoint.xs
    }
  },
  watch: {
    pageSize () {
      this.fetchCustomers(1)
    },
    filters: {
      deep: true,
      handler () {
        this.selectedCustomers = []
        this.fetchCustomers(1)
      }
    }
  },
  created () {
    this.$store.commit('customers/resetFilters')
    this.fetchCustomFields()
  },
  methods: {
    ...mapActions(['showMessage']),
    addFilter () {
      this.showFilterDrawer = true
    },
    getCustomers (page, pageSize, query, filters) {
      const params = {
        page_size: pageSize,
        page,
        search: query || '',
        expand: 'member'
      }
      if (this.isGroupMode) {
        params['groups'] = this.segment.id
      }
      for (const key in filters) {
        const value = filters[key]
        if (value) {
          if (key === 'custom_data') {
            if (value.size) {
              const customParams = []
              for (const [filterKey, val] of value) {
                if (val) {
                  for (const k in val) {
                    const d = val[k]
                    if (d) {
                      const param = `${filterKey},${k},${d}`
                      customParams.push(param)
                    }
                  }
                }
              }
              params['custom_data'] = customParams.join('__')
            }
          } else {
            params[key] = value
          }
        }
      }
      return this.$axios.get(`/connect/${this.company.slug}/customers`, { params })
    },
    fetchCustomers (page, query) {
      this.isLoading = true
      this.getCustomers(page, this.pageSize, query, this.filters)
        .then(resp => {
          const data = resp.data
          this.checkAll = false
          this.customers = data.results
          const selectedIds = this.selectedCustomers.map(item => item.id)
          this.customers.map(item => {
            item.checked = false
            if (this.previousCustomers) {
              if (this.previousCustomers.includes(item.id)) {
                item.checked = true
              }
            }
            if (selectedIds.includes(item.id)) {
              item.checked = true
            }
          })
          this.totalCount = data.count
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    fetchCustomFields () {
      this.$axios.get(`/connect/${this.company.slug}/customer_custom_fields?page_size=-1`)
        .then(resp => {
          const results = resp.data?.results
          if (results) {
            const fields = []
            results.forEach(field => {
              field.enable = false
              fields.push(field)
            })
            this.$store.commit('customers/setCustomFields', fields)
          }
        })
        .catch(() => {})
    },
    pageChanged (num) {
      this.fetchCustomers(num)
    },
    queryChanged: debounce (function (query) {
      this.fetchCustomers(1, query)
    }, 750),
    successDeleteCustomer () {
      this.reset()
    },
    onChecked () {
      this.selectedCustomers = this.customers.filter(item => item.checked === true)
      this.customers = [...this.customers]
      this.checkAll = false
      this.emitSelectedCustomers()
    },
    onCheckedAll () {
      const clone = [...this.customers]
      clone.map(item => item.checked = this.checkAll)
      this.customers = [...clone]
      this.selectedCustomers = this.customers.filter(item => item.checked === true)
      this.emitSelectedCustomers()
    },
    clearSelection () {
      this.checkAll = false
      this.onCheckedAll()
    },
    onDelete () {
      this.showDeleteDialog = true
    },
    onDeleteCustomerSegment () {
      this.showDeleteCustomerSegment = true
    },
    onAddSegment () {
      this.showAddDialog = true
    },
    onSendSms () {
      this.$store.commit('customers/setSelectedCustomers', this.selectedCustomers)
      this.$router.push(`/admin/connect/customers/send-message`)
    },
    onSendEmail () {
      this.$store.commit('customers/setSelectedCustomers', this.selectedCustomers)
      this.$router.push(`/admin/connect/customers/send-email`)
    },
    successAddCustomer () {
      this.showAddCustomerDialog = false
      this.reset()
    },
    reset () {
      this.checkAll = false
      this.selectedCustomers = []
      this.fetchCustomers(1)
    },
    onContinue () {
      this.$emit('onContinue', this.selectedCustomers)
    },
    emitSelectedCustomers () {
      this.$emit('onSelectedCustomers', this.selectedCustomers)
    },
    addCustomer () {
      this.showAddCustomerDialog = true
    },
    onChanged (i) {
      this.selectedAddCustomerOption = this.addCustomerOptions[i]
    },
    confirmAddCustomer () {
      switch (this.selectedAddCustomerOption.id) {
        case 'create':
          this.showCreateCustomerDialog = true
          break
        case 'csv':
          this.$router.push('/admin/connect/customers/upload-csv')
          break
      }
    },
    getFieldData (id, field) {
      const data = field[id]
      if (data) {
        return data
      }
      if (field.custom_data.length) {
        const custom = field.custom_data.find(i => `${i.id}` === id)
        if (custom) {
          return custom.value
        }
      }
      return ''
    }
  }
}
</script>

<style scoped>
.sticky-column {
  position: sticky !important;
  left: 0 !important;
  background-color: white;
}
</style>